import Create from './create'

export default Create
